export default "__VITE_ASSET__4c385ad9__"